import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=50e1d11a&scoped=true"
import script from "./PageContent.vue?vue&type=script&lang=js"
export * from "./PageContent.vue?vue&type=script&lang=js"
import style0 from "./PageContent.vue?vue&type=style&index=0&id=50e1d11a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e1d11a",
  null
  
)

export default component.exports